<template>
  <div class="irrigationRecordManagement-page">
    <div class="all-content-container">
      <div class="table-content-container" style="overflow: hidden">
        <div class="table-title-container flexC">
          <div class="flexC">
            <h4>水管</h4>
            <p @click="canlan" style="margin-left: 20px; cursor: pointer">
              <i class="el-icon-caret-left"></i>
              <span>返回</span>
            </p>
          </div>
          <el-button
            style="margin-right: 20px"
            @click="_addEditSwitch()"
            size="small"
            type="primary"
            >+水管</el-button
          >
        </div>
        <div class="table-content">
          <div class="table-table">
            <el-table
              :data="tableData"
              style="width: 100%"
              :header-cell-style="{ background: '#f4f5f7' }"
              v-loading="loading"
            >
              <el-table-column
                prop="name"
                label="水管名称"
                align="center"
              ></el-table-column>
              <el-table-column label="数值设备" align="center">
                <template slot-scope="scope">
                  <span
                    >{{ scope.row.numericalEquipmentName }}_{{
                      scope.row.numericalEquipmentAttribute
                    }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column label="开关设备" align="center">
                <template slot-scope="scope">
                  <span
                    >{{ scope.row.switchEquipmentName }}_{{
                      scope.row.switchEquipmentAttribute
                    }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                prop="positionNum"
                label="位置"
                align="center"
              ></el-table-column>
              <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                  <el-button
                    @click="_addEditSwitch(scope.row.id)"
                    type="text"
                    size="small"
                    >编辑</el-button
                  >
                  <el-button
                    type="text"
                    size="small"
                    @click="_delSwitch(scope.row.id)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="pagination-content-container" style="float: right">
          <el-pagination
            background
            layout="prev, pager, next,jumper"
            class="pageTap"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-size="pageSize"
            :total="total"
          ></el-pagination>
        </div>
        <el-dialog title="开关配置" :visible.sync="formSubIs" width="700px">
          <el-form
            :inline="true"
            ref="form"
            :rules="dialogRules"
            :model="formSub"
            label-width="100px"
          >
            <el-form-item
              label="水管名称："
              prop="name"
              :label-width="formLabelWidth"
            >
              <el-input
                class="w500"
                placeholder="请输入水管名称"
                v-model="formSub.name"
                maxlength="20"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item
              label="数值设备："
              prop="numericalEquipmentId"
              :label-width="formLabelWidth"
            >
              <el-select
                class="w500"
                v-model="formSub.numericalEquipmentId"
                placeholder="请选择数值设备"
              >
                <el-option
                  v-for="(item, index) in allcmd00"
                  :stype="item.switchType"
                  :key="index"
                  :label="item.deviceName + '_' + item.attributeName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="开关类型："
              prop="numericalEquipmentId"
              :label-width="formLabelWidth"
            >
              <el-select
                class="w500"
                v-model="formSub.type"
                placeholder="请选择开关类型"
              >
               	<el-option
                  v-for="(item, index) in alltype"
                  :key="index"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="开关设备："
              prop="switchEquipmentId"
              :label-width="formLabelWidth"
            >
              <el-select
                class="w500"
                v-model="formSub.switchEquipmentId"
                placeholder="请选择开关设备"
              >
                <el-option
                  v-for="(item, index) in allcmd11"
                  :stype="item.switchType"
                  :key="index"
                  :label="item.deviceName + '_' + item.attributeName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="位置排序："
              prop="positionNum"
              :label-width="formLabelWidth"
            >
              <el-input
                class="w500"
                placeholder="请输入位置排序(1-20)"
                v-model="formSub.positionNum"
                maxlength="2"
                clearable
              ></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="resetForm(), (formSubIs = false)"
              >取 消</el-button
            >
            <el-button type="primary" @click="submitForm('form')"
              >确 定</el-button
            >
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      id: "",
      linkageControlId: "",
      hisDataIrrigationList: [],
      loading: false,
      formLabelWidth: "120px",
      formSubIs: false,
      formSub: {
        type: "0",
        name: "",
        numericalEquipmentId: "",
        positionNum: "",
        switchEquipmentId: "",
      },
      alltype: [
        {
          name: "普通开关",
          value: 0,
        },
        {
          name: "总开关",
          value: 1,
        },
      ],
      allcmd00: [],
      allcmd11: [],
      dialogRules: {
        name: [
          { message: "请输入水管名称", trigger: "change", required: true },
        ],
        numericalEquipmentId: [
          { required: true, message: "请选择数值设备", trigger: "change" },
        ],
        switchEquipmentId: [
          { required: true, message: "请选择开关设备", trigger: "change" },
        ],
        positionNum: [
          {
            required: true,
            message: "请输入位置排序(1-20)",
            trigger: "change",
          },
          {
            validator(rule, value, callback) {
              if (
                Number.isInteger(Number(value)) &&
                Number(value) >= 1 &&
                Number(value) <= 20
              ) {
                callback();
              } else {
                callback(new Error("请输入位置排序(1-20)"));
              }
            },
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.linkageControlId = this.$route.query.linkageControlId;
  },
  mounted() {
    this._getWaterPipeList();
    this._getDeviceByEquipmentId(0); //开关
    this._getDeviceByEquipmentId(3); //数值
  },
  methods: {
    _addEditSwitch(id) {
      this.formSubIs = true;
      if (id) {
        this.$api.device.getWaterPipe({ id: id }).then((res) => {
          if (res.code == 200) {
            this.formSub = {
              type: res.data.type,
              id: res.data.id,
              name: res.data.name,
              numericalEquipmentId: res.data.numericalEquipmentId,
              positionNum: res.data.positionNum,
              switchEquipmentId: res.data.switchEquipmentId,
            };
          }
        });
      } else {
        this.formSub = {};
      }
    },
    _getDeviceByEquipmentId(type) {
      this.$api.device
        .getDeviceByEquipmentId2(this.linkageControlId, type)
        .then((res) => {
          if (res.code == 200) {
            if (type == 0) {
              this.allcmd00 = res.data;
            } else {
              this.allcmd11 = res.data;
            }
          }
        });
    },
    _delSwitch(id) {
      this.$confirm("是否删除？", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api.system
            .delfun(`/pc/agriConfigWaterPipe/delWaterPipe`, id)
            .then((res) => {
              if (res.code == 200) {
                this.$message({ type: "success", message: res.msg });
                this._getWaterPipeList();
              } else {
                this.$message.error(res.msg);
              }
            });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    resetForm() {
      this.$refs["form"].resetFields();
    },
    submitForm(formName) {
      // 提交表单
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$api.device
            .saveWaterPipe({
              ...this.formSub,
              integratedGroupId: this.id,
            })
            .then((res) => {
              if (res.code == 200) {
                this.resetForm();
                this.formSubIs = false;
                this.$toaster.ok(res.msg);
                this._getWaterPipeList();
              }
            });
        } else {
          return false;22
        }
      });
    },
    //  查询水肥一体化_水管列表
    _getWaterPipeList() {
      this.loading = true;
      this.$api.device
        .getWaterPipeList({
          integratedGroupId: this.id,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        })
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
            this.total = res.count;
            this.loading = false;
          } else {
            this.loading = false;
          }
        });
    },
    // 分页
    handleCurrentChange(currentPage) {
      this.pageNum = currentPage;
      this._getWaterPipeList();
    },
    // 返回
    canlan() {
      this.$router.push({
        name: "fertilizerManagement",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/irrigationRecordManagement.scss";
.w500 {
  width: 500px;
}
.flexC {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 20px;
}
.el-form-item {
  margin-bottom: 20px;
}
</style>